import { S2DApiPaginatedData } from "../../../api/common/apiResponse";
import { DeclarationType } from "../../app/eDeclarations";
import { DeclarationStatus } from "../../shared/statuses";

export type DriverDeclaration = {
    firstName: string;
    lastName: string;
    declarationId: string;
    inFlightDeclarationId: string | null;
    inFlightDeclarationType: DeclarationType | null;
    inFlightDeclarationStatus: DeclarationStatus | null;
    driverId: string;
    companyName: string;
    department: null | string;
    emailAddress: string;
    declarationExpires: null | string; // date
    licenceOrigin: string;
    declarationStatus: DeclarationStatus;
    declarationType: DeclarationType;
    declarationLastSent: null | string; // date
};

export type ApiEDeclarationsResponse = S2DApiPaginatedData<DriverDeclaration>;

export enum DeclarationsOrderByOptions {
    FirstName = "FirstName",
    LastName = "LastName",
    LicenceNumber = "LicenceNumber",
    DateOfBirth = "DateOfBirth",
    EmailAddress = "EmailAddress",
    EmployeeId = "EmployeeId",
    ExternalReference = "ExternalReference",
    AddressPostcode = "AddressPostcode",
    Company = "Company.CompanyName",
    Department = "Department.DepartmentName",
}
